import { z } from "zod"

const MessengerIntegration = z.object({
  id: z.bigint().transform(String),
  name: z.string(),
  pageId: z.string(),
  profilePicture: z.string().nullish(),
  campaignsCount: z.number(),
  createdAt: z.date().transform((value) => value.toISOString()),
  failedAt: z
    .date()
    .transform((value) => value.toISOString())
    .nullish(),
})

export const MessengerIntegrationsResponseData = z.array(MessengerIntegration)
